/* FAQ accordion */
document.addEventListener("click", function(e){

  let btn = e.target.closest(".custom-faq__question");

  if(btn){

    let item = btn.closest(".custom-faq__item");

    item.classList.toggle("active");

  }

});



/* FAQ sidebar smooth scroll */
document.querySelectorAll(".custom-faq__nav").forEach(function(link){

  link.addEventListener("click", function(e){

    e.preventDefault();

    let target = document.querySelector(
      this.getAttribute("href")
    );

    if(target){

      let headerOffset = 120; // sticky header height
      let elementPosition = target.getBoundingClientRect().top;
      let offsetPosition = elementPosition + window.pageYOffset - headerOffset;


      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });

    }

  });

});